import 'css-chunksrc/client/pages/workloadPage/styles.scss';export default {
  "workloadPage": "_workloadPage_lbteu_1",
  "header": "_header_lbteu_9",
  "profileNavigation": "_profileNavigation_lbteu_19",
  "title": "_title_lbteu_27",
  "menu": "_menu_lbteu_33",
  "legend": "_legend_lbteu_42",
  "unit": "_unit_lbteu_48",
  "content": "_content_lbteu_54",
  "tableContainer": "_tableContainer_lbteu_65",
  "error": "_error_lbteu_71",
  "empty": "_empty_lbteu_72",
  "retry": "_retry_lbteu_83"
};